<template>
  <el-container class='box'>
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' v-on:getSearchObj='getSearchObj' :rightEventList='rightEventList'
        @rightFunc='rightFunc' />
    </div>
    <el-main class="listTabel" style="padding-bottom: 0;">
      <BaseTable :data="tableData" :optimize='true' tooltip-effect="dark" :column="tableConfig" pagination
        :auto-scroll="true" :total="total" :page.sync="searchParams.current" :limit.sync="searchParams.size"
        @pagination="getList">
      </BaseTable>
    </el-main>

    <!-- 添加编辑弹窗 -->
    <el-dialog :visible.sync="showAddQuestion" :close-on-click-modal="false" :before-close="closeClick" width="564px"
      :title="titleName">
      <div class="dialog-main-content">
        <el-form :model="formStepFirst" label-width="100px" :rules="rulesFormFirst" ref="formStepFirst"
          label-position="right" class="edit" size="small">
          <el-form-item label="发起机构:" prop="fromOrgId">
            <div class="label-item">
              <el-select v-model="formStepFirst.fromOrgId" placeholder="请选择发起机构" value-key="diseaseId" filterable
                @change="initiatorChange" v-if="type != 'see'">
                <el-option v-for="item in initiatorList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.fromOrgName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="发起科室:" prop="fromDeptIds">
            <div class="label-item">
              <el-cascader filterable placeholder="请选择发起科室" class="f-input" v-model="formStepFirst.fromDeptIds"
                :options="initiatingDepartmentList" :props="labelProps" @change="initiatingDepartmentChange"
                v-if="type != 'see'">
              </el-cascader>
              <span v-else>{{ formStepFirstSee.fromDeptName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="发起团队:" prop="fromTeamId" filterable>
            <div class="label-item">
              <el-select v-model="formStepFirst.fromTeamId" placeholder="请选择发起团队" value-key="diseaseId" filterable
                @change="initiatingTeamChange" v-if="type != 'see'">
                <el-option v-for="item in initiatingTeamList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.fromTeamName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="发起医生:" prop="fromDoctorId">
            <div class="label-item">
              <el-select v-model="formStepFirst.fromDoctorId" placeholder="请选择发起医生" value-key="suborderName" filterable
                @change="initiatingPhysicianChange" v-if="type != 'see'">
                <el-option v-for="item in initiatingPhysicianList" :key="item.doctorId" :label="item.name" :value="item.doctorId">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.fromDoctorName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="上级机构:" prop="toOrgId">
            <div class="label-item">
              <el-select v-model="formStepFirst.toOrgId" placeholder="请选择上级机构" value-key="diseaseId" filterable
                @change="institutionChange" v-if="type != 'see'">
                <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.toOrgName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="上级科室:" prop="toDeptIds">
            <div class="label-item">
              <el-cascader filterable placeholder="请选择上级科室" class="f-input" v-model="formStepFirst.toDeptIds"
                :options="administrativeOfficeList" :props="labelProps" @change="administrativeOfficeChange"
                v-if="type != 'see'">
              </el-cascader>
              <span v-else>{{ formStepFirstSee.toDeptName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="上级团队:" prop="toTeamId" filterable>
            <div class="label-item">
              <el-select v-model="formStepFirst.toTeamId" placeholder="请选择上级团队" value-key="diseaseId" filterable
                @change="teamChange" v-if="type != 'see'">
                <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.toTeamName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="上级医生:">
            <div class="label-item">
              <el-select v-model="formStepFirst.toDoctorId" placeholder="请选择上级医生" value-key="suborderName" filterable clearable
                @change="doctorChange" v-if="type != 'see'">
                <el-option v-for="item in doctorList" :key="item.doctorId" :label="item.name" :value="item.doctorId">
                </el-option>
              </el-select>
              <span v-else>{{ formStepFirstSee.toDoctorName }}</span>
            </div>
          </el-form-item>
        </el-form>
        <div class="btn-box" v-if="type != 'see'">
          <el-button @click="resetClick('formStepFirst')" size="small">重置</el-button>
          <el-button type="primary" @click="saveClick('formStepFirst')" size="small">保存</el-button>
        </div>
      </div>
    </el-dialog>

  </el-container>
</template>

<script>
import {
  pageList,
  orgList,
  departmentList,
  doctorTeamList,
  doctorTeamMemberTeamList,
  synergyRelationAdd,
  synergyRelationEdit,
  synergyRelationDetail,
  state,
  synergyRelationDelete
} from "@/api/cooperativeRelationship";

export default {
  components: {},
  props: {},
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "协同关系配置" }],
      rightEventList: [{ eventName: "新增协同关系", eventValue: 1 }],
      curRow: {},
      searchList: [
        {
          label: "发起医生",
          value: 1,
          paramName: "fromDoctorName",
          inputType: "input"
        },
        {
          label: "上级医生",
          value: 3,
          paramName: "toDoctorName",
          inputType: "input"
        },
        {
          label: "创建",
          value: 2,
          paramName: "updateTime",
          inputType: "datetimerange",
          paramstartTime: "startCreateTime",
          paramEndTime: "endCreateTime",
          isTime: true,
          showLabel:true,
        }
      ],
      searchParams: {
        size: 10,
        current: 1
      },
      tableData: [],
      tableConfig: [
        // {
        //   label: "合作类型",
        //   align: "center",
        //   showOverflowTooltip:true,
        //   render: (h, scope) => {
        //     return (
        //       <span slot="reference">
        //         {scope.row.cooperationType.length ? scope.row.cooperationType.map(v => v.cooperationTypeName).join('、') : '-'}
        //       </span>
        //     );
        //   }
        // },
        {
          label: "序号",
          align: "center",
          prop: "index",
          fixed: "left",
          size: "mini"
        },
        {
          label: "发起机构",
          align: "center",
          prop: "fromOrgName"
        },
        {
          label: "发起科室",
          align: "center",
          prop: "fromDeptName"
        },
        {
          label: "发起团队",
          align: "center",
          prop: "fromTeamName"
        },
        {
          label: "发起医生",
          align: "center",
          prop: "fromDoctorName"
        },
        {
          label: "上级机构",
          align: "center",
          prop: "toOrgName"
        },
        {
          label: "上级科室",
          align: "center",
          prop: "toDeptName"
        },
        {
          label: "上级团队",
          align: "center",
          prop: "toTeamName"
        },

        {
          label: "上级医生",
          align: "center",
          prop: "toDoctorName"
        },
        {
          label: "创建时间",
          align: "center",
          prop: "createTime",
          width: "165px",
        },
        {
          label: "更新时间",
          align: "center",
          prop: "updateTime",
          width: "165px",
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onLookClick(scope.row);
                    }
                  }
                },
                "查看"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.enableClick(scope.row);
                    }
                  }
                },
                scope.row.synergyRelationState == "ENABLE" ? "禁用" : "启用"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini",
                    disabled:
                      scope.row.synergyRelationState == "ENABLE" ? true : false
                  },
                  on: {
                    click: () => {
                      this.editClick(scope.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini",
                    disabled:
                      scope.row.synergyRelationState == "ENABLE" ? true : false
                  },
                  on: {
                    click: () => {
                      this.deleteClick(scope.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      total: 0,
      showAddQuestion: false,
      formStepFirst: {
        //表单value值
        fromOrgId: null,
        fromDeptId: null,
        fromDeptIds: [],
        fromTeamId: null,
        fromDoctorId: null,
        toOrgId: null,
        toDeptId: null,
        toDeptIds: [],
        toTeamId: null,
        toDoctorId: null,
        fromDoctorName: null,
        toDoctorName: null
      },
      formStepFirstSee: {
        fromOrgName: null,
        fromDeptName: null,
        fromTeamName: null,
        fromDoctorName: null,
        toOrgName: null,
        toDeptName: null,
        toTeamName: null,
        toDoctorName: null
      },
      rulesFormFirst: {
        //验证表单
        fromOrgId: [
          { required: true, message: "请选择发起机构", trigger: "blur,change" }
        ],
        fromDeptIds: [
          { required: true, message: "请选择发起机构", trigger: "blur,change" }
        ],
        fromTeamId: [
          { required: true, message: "请选择发起团队", trigger: "blur,change" }
        ],
        fromDoctorId: [
          { required: true, message: "请选择发起医生", trigger: "blur,change" }
        ],
        toOrgId: [
          { required: true, message: "请选择上级机构", trigger: "blur,change" }
        ],
        toDeptIds: [
          { required: true, message: "请选择上级科室", trigger: "blur,change" }
        ],
        toTeamId: [
          { required: true, message: "请选择上级团队", trigger: "blur,change" }
        ],
        toDoctorId: [
          { required: true, message: "请选择上级医生", trigger: "blur,change" }
        ]
      },
      initiatorList: [], //发起机构
      initiatingDepartmentList: [], //发起科室
      initiatingTeamList: [], //发起团队
      initiatingPhysicianList: [], //发起医生
      institutionList: [], //机构
      administrativeOfficeList: [], //科室
      teamList: [], //团队
      doctorList: [], //医生
      titleName: "新增协同",
      type: null,
      hospitalIdOne: null,
      hospitalIdTwo: null,
      openDepartmentIdOne: null,
      openDepartmentIdTwo: null,
      teamIdOne: null,
      teamIdTwo: null,
      id: null,
      labelProps: {
        value: "id",
        label: "name",
        children: "children"
      }
    };
  },

  watch: {},
  computed: {},
  created() {
    this.getList();
    this.orgListRequest();
  },
  methods: {
    onLookClick(row) {
      this.showAddQuestion = true;
      this.titleName = "查看协同";
      this.type = "see";
      this.id = row.id;
      this.formStepFirstSee = row;
      // this.synergyRelationDetailRequest();
    },

    editClick(row) {
      this.showAddQuestion = true;
      this.titleName = "编辑协同";
      this.type = "edit";
      this.id = row.id;
      this.synergyRelationDetailRequest();
    },
    enableClick(item) {
      //启用 禁用
      if (item.synergyRelationState == "DISABLE") {
        this.$confirm("确定启用此协同关系吗？", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {
            state({
              id: item.id,
              synergyRelationState: "ENABLE"
            }).then(res => {
              if (res.code == 0) {
                this.$message.success("启用成功");
                this.getList();
              }
            });
          })
          .catch(() => {});
      } else {
        this.$confirm("确定禁用此协同关系吗？", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {
            state({
              id: item.id,
              synergyRelationState: "DISABLE"
            }).then(res => {
              if (res.code == 0) {
                this.$message.success("禁用成功");
                this.getList();
              }
            });
          })
          .catch(() => {});
      }
    },
    deleteClick(item) {
      this.$confirm("确定删除此协同关系吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      })
        .then(() => {
          synergyRelationDelete({
            id: item.id
          }).then(res => {
            if (res.code == 0) {
              if (this.tableData.length == 1) {
                this.searchParams.current = this.searchParams.current - 1;
              } else {
                this.searchParams.current = 1;
              }
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...this.searchParams, ...obj };
      this.getList();
    },
    getList() {
      pageList(this.searchParams).then(res => {
        if (res.code == 0) {
          this.total = res.data.total;
          if (res.data && res.data.records) {
            this.tableData = res.data.records.map((item, index) => {
              return {
                ...item,
                index: index + 1
              };
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    orgListRequest() {
      this.initiatorList = [];
      this.institutionList = [];
      orgList({
        name: null,
        disabled: false,
        isTest: null
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.initiatorList = res.data;
            this.institutionList = res.data;
          } else {
            this.initiatorList = [];
            this.institutionList = [];
          }
        }
      });
    },
    departmentListRequestOne() {
      this.initiatingDepartmentList = [];
      departmentList({
        disabled: false,
        hospitalId: this.hospitalIdOne
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.initiatingDepartmentList = res.data;
          } else {
            this.initiatingDepartmentList = [];
          }
        }
      });
    },
    departmentListRequestTwo() {
      this.administrativeOfficeList = [];
      departmentList({
        disabled: false,
        hospitalId: this.hospitalIdTwo
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.administrativeOfficeList = res.data;
          } else {
            this.administrativeOfficeList = [];
          }
        }
      });
    },
    doctorTeamListRequestOne() {
      this.initiatingTeamList = [];
      console.log(this.openDepartmentIdOne, "this.openDepartmentIdOne");
      doctorTeamList({
        disabled: false,
        openDepartmentId: this.openDepartmentIdOne
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.initiatingTeamList = res.data;
          } else {
            this.initiatingTeamList = [];
          }
        }
      });
    },
    doctorTeamListRequestTwo() {
      this.teamList = [];
      doctorTeamList({
        disabled: false,
        openDepartmentId: this.openDepartmentIdTwo
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.teamList = res.data;
          } else {
            this.teamList = [];
          }
        }
      });
    },
    doctorTeamMemberTeamListRequestOne() {
      this.initiatingPhysicianList = [];
      doctorTeamMemberTeamList({
        teamId: this.teamIdOne
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.initiatingPhysicianList = res.data;
          } else {
            this.initiatingPhysicianList = [];
          }
        }
      });
    },
    doctorTeamMemberTeamListRequestTwo() {
      this.doctorList = [];
      doctorTeamMemberTeamList({
        teamId: this.teamIdTwo
      }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.doctorList = res.data;
          } else {
            this.doctorList = [];
          }
        }
      });
    },
    synergyRelationDetailRequest() {
      synergyRelationDetail({ id: this.id }).then(res => {
        if (res.code == 0) {
          console.log(res.data);
          if (res.data) {
            if (res.data.fromOrgId) {
              this.hospitalIdOne = res.data.fromOrgId;
              this.departmentListRequestOne();
            }
            if (res.data.fromDeptId) {
              console.log(res.data.fromDeptId, "res.data.fromDeptId");
              this.openDepartmentIdOne = res.data.fromDeptId;
              this.doctorTeamListRequestOne();
            }
            if (res.data.fromTeamId) {
              this.teamIdOne = res.data.fromTeamId;
              this.doctorTeamMemberTeamListRequestOne();
            }
            if (res.data.toOrgId) {
              this.hospitalIdTwo = res.data.toOrgId;
              this.departmentListRequestTwo();
            }
            if (res.data.toDeptId) {
              this.openDepartmentIdTwo = res.data.toDeptId;
              this.doctorTeamListRequestTwo();
            }
            if (res.data.toTeamId) {
              this.teamIdTwo = res.data.toTeamId;
              this.doctorTeamMemberTeamListRequestTwo();
            }
            setTimeout(() => {
              this.formStepFirst = res.data;
              this.formStepFirst.fromDeptIds = [];
              this.initiatingDepartmentList.forEach((item, index) => {
                if (item.id == res.data.fromDeptId) {
                  this.formStepFirst.fromDeptIds.push(res.data.fromDeptId);
                } else {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach((el, i) => {
                      if (el.id == res.data.fromDeptId) {
                        this.formStepFirst.fromDeptIds.push(item.id);
                        this.formStepFirst.fromDeptIds.push(
                          res.data.fromDeptId
                        );
                      }
                    });
                  }
                }
              });
              this.formStepFirst.toDeptIds = [];
              this.administrativeOfficeList.forEach((item, index) => {
                if (item.id == res.data.toDeptId) {
                  this.formStepFirst.toDeptIds.push(res.data.toDeptId);
                } else {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach((el, i) => {
                      if (el.id == res.data.toDeptId) {
                        this.formStepFirst.toDeptIds.push(item.id);
                        this.formStepFirst.toDeptIds.push(res.data.toDeptId);
                      }
                    });
                  }
                }
              });
            }, 1000);
          }
        }
      });
    },
    rightFunc(item) {
      this.showAddQuestion = true;
      this.type = "add";
      this.titleName = "新增协同";
      this.resetFun();
    },
    initiatorChange(e) {
      //发起机构
      this.formStepFirst.fromOrgId = e;
      this.hospitalIdOne = e;
      this.formStepFirst.fromDeptId = null;
      this.formStepFirst.fromTeamId = null;
      this.formStepFirst.fromDoctorId = null;
      this.departmentListRequestOne();
    },
    initiatingDepartmentChange(e) {
      //发起科室
      if (e instanceof Array) {
        this.openDepartmentIdOne = e[e.length - 1];
        this.formStepFirst.fromDeptId = e[e.length - 1];
      } else {
        this.openDepartmentIdOne = e;
        this.formStepFirst.fromDeptId = e;
      }
      this.formStepFirst.fromTeamId = null;
      this.formStepFirst.fromDoctorId = null;
      console.log(
        this.formStepFirst.fromDeptId,
        "this.formStepFirst.fromDeptId"
      );
      this.doctorTeamListRequestOne();
    },
    initiatingTeamChange(e) {
      //发起团队
      this.teamIdOne = e;
      this.formStepFirst.fromDoctorId = null;
      this.doctorTeamMemberTeamListRequestOne();
    },
    initiatingPhysicianChange(e) {
      //发起医生
      let arr = this.initiatingPhysicianList.filter(item => item.doctorId == e);
      if (arr.length > 0) {
        this.formStepFirst.fromDoctorName = arr[0].name;
      }
    },
    institutionChange(e) {
      //机构
      this.hospitalIdTwo = e;
      this.formStepFirst.toDeptId = null;
      this.formStepFirst.toTeamId = null;
      this.formStepFirst.toDoctorId = null;
      this.departmentListRequestTwo();
    },
    administrativeOfficeChange(e) {
      //科室
      if (e instanceof Array) {
        this.openDepartmentIdTwo = e[e.length - 1];
        this.formStepFirst.toDeptId = e[e.length - 1];
      } else {
        this.openDepartmentIdTwo = e;
        this.formStepFirst.toDeptId = e;
      }
      this.formStepFirst.toTeamId = null;
      this.formStepFirst.toDoctorId = null;
      console.log(this.formStepFirst.toDeptId, "this.formStepFirst.toDeptId");
      this.doctorTeamListRequestTwo();
    },
    teamChange(e) {
      //团队
      console.log(e);
      this.teamIdTwo = e;
      this.formStepFirst.toDoctorId = null;
      this.doctorTeamMemberTeamListRequestTwo();
    },
    doctorChange(e) {
      //医生
      console.log(e);
      let arr = this.doctorList.filter(item => item.doctorId == e);
      if (arr.length > 0) {
        this.formStepFirst.toDoctorName = arr[0].name;
      }
    },
    closeClick() {
      //关闭
      this.showAddQuestion = false;
      this.$refs["formStepFirst"].resetFields();
    },
    resetClick(formName) {
      //重置
      this.resetFun();
      this.$refs[formName].resetFields();
    },
    resetFun() {
      this.formStepFirst.toDoctorId = null;
      this.formStepFirst.fromDeptIds = [];
      this.formStepFirst.toDeptIds = [];
      this.initiatingDepartmentList = [];
      this.initiatingTeamList = [];
      this.initiatingPhysicianList = [];
      this.administrativeOfficeList = [];
      this.teamList = [];
      this.doctorList = [];

      this.formStepFirst = {
        fromOrgId: null,
        fromDeptId: null,
        fromTeamId: null,
        fromDoctorId: null,
        toOrgId: null,
        toDeptId: null,
        toTeamId: null,
        toDoctorId: null
      };
    },
    saveClick(formName) {
      //保存
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.type == "edit") {
            synergyRelationEdit({
              ...this.formStepFirst,
              id: this.id
            }).then(res => {
              if (res.code == 0) {
                this.showAddQuestion = false;
                this.$refs[formName].resetFields();
                this.$message.success("编辑成功");
                this.getList();
              }
            });
          } else {
            synergyRelationAdd({
              ...this.formStepFirst
              // fromDeptId:this.formStepFirst.fromDeptId[this.formStepFirst.fromDeptId.length -1],
              // toDeptId:this.formStepFirst.toDeptId[this.formStepFirst.toDeptId.length -1],
            }).then(res => {
              if (res.code == 0) {
                this.showAddQuestion = false;
                this.$refs[formName].resetFields();
                this.$message.success("新增成功");
                this.getList();
              }
            });
          }
        } else {
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 20px;
  margin-right: 30px;
  padding-bottom: 20px;
}
.mr10 {
  margin-right: 10px;
}
/deep/.el-form-item {
  margin-right: 10px;
  margin: 0 0 20px 0 !important;
}
/deep/.el-tag {
  margin-left: 5px;
}
.dialog-main-content {
  .el-select {
    width: 100%;
  }
  .el-form-item--mini.el-form-item {
    margin: 0 0 20px 0 !important;
  }
}
.btn-box {
  text-align: center;
  margin-bottom: 15px;
}
.f-input {
  width: 100%;
}
/deep/.el-dialog__header{
  padding-bottom: 0px;
}
</style>